<template>
    <div>
        <b-tabs :nav-class="tabsNavClass">
            <b-tab :title="$t('Vue.Grid.OrderRequestsGrid.TabLabel.ClientCourtOrderRequests')" :active="(initialTab == 'Court')" v-on:click="tabActivated(court)">
                <filter-ui :fields="court.filterFields" ref="clientCourtOrderRequestsGridFilter" :api-base-url="$urlHelper.apiBaseUrl" relatedTo="clientCourtOrderRequests" :filter="court.initialFilter" v-on:change="courtFilterChanged"></filter-ui>
                <ejs-grid id="clientCourtOrderRequestsGrid"
                          ref="clientCourtOrderRequestsGrid"
                          :dataSource="court.gridData"
                          :allowSorting="true"
                          :sortSettings="court.sortSettings"
                          :toolbar="toolbar"
                          :allowGrouping="false"
                          :groupSettings="groupSettings"
                          :allowResizing="true"
                          :allowPaging="true"
                          :pageSettings="pageSettings"
                          :showColumnChooser="true"
                          :allowExcelExport="true"
                          :dataStateChange="courtGridDataStateChanged"
                          :queryCellInfo="customiseCell"
                          :rowSelected="courtGridRowSelectionChanged"
                          :rowDeselected="courtGridRowSelectionChanged"
                          :toolbarClick="courtGridToolbarClicked"
                          :created="gridCreated(court)"
                          :headerCellInfo="headerCellInfoEvent"
                          :enableStickyHeader="true"                          
                          v-if="court.show">
                    <e-columns>
                        <e-column field="orderRequestNumberDisplayText" :headerText="$t('Entities.ClientOrderRequest.OrderRequestNumber')" width="100"></e-column>
                        <e-column field="orderingClientName" headerText="Client" v-if="!isClient"></e-column>
                        <e-column field="orderingClientBranchName" headerText="Branch/Location"></e-column>
                        <e-column field="orderingClientContactName" headerText="Client Contact" v-if="!isClient"></e-column>
                        <e-column field="courtRegistryName" headerText="Court/Tribunal/Other"></e-column>
                        <e-column field="matterNumber" :headerText="$t('Vue.Grid.Shared.HeaderText.MatterNumber')"></e-column>
                        <e-column field="matterName" :headerText="$t('Vue.Grid.Shared.HeaderText.MatterName')"></e-column>
                        <e-column field="courtSittingDate" headerText="Sitting Date"></e-column>
                        <e-column field="clientReference" headerText="Client Reference"></e-column>
                        <e-column field="serviceTypeName" headerText="Service Type"></e-column>
                        <e-column field="serviceDelayName" headerText="Turnaround"></e-column>
                        <e-column field="statusDisplayName" headerText="Status" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="effectiveLastUpdateDateTimeUTC" headerText="Last Update"></e-column>
                    </e-columns>
                </ejs-grid>
            </b-tab>
            <b-tab :title="$t('Vue.Grid.OrderRequestsGrid.TabLabel.ClientInterviewOrderRequests')" :active="(initialTab == 'Interview')" v-on:click="tabActivated(interview)">
                <filter-ui :fields="interview.filterFields" ref="clientInterviewOrderRequestsGridFilter" :api-base-url="$urlHelper.apiBaseUrl" relatedTo="clientInterviewOrderRequests" :filter="interview.initialFilter" v-on:change="interviewFilterChanged"></filter-ui>
                <ejs-grid id="clientInterviewOrderRequestsGrid"
                          ref="clientInterviewOrderRequestsGrid"
                          :dataSource="interview.gridData"
                          :allowSorting="true"
                          :sortSettings="interview.sortSettings"
                          :toolbar="toolbar"
                          :allowGrouping="false"
                          :allowResizing="true"
                          :allowPaging="true"
                          :pageSettings="pageSettings"
                          :showColumnChooser="true"
                          :allowExcelExport="true"
                          :dataStateChange="interviewGridDataStateChanged"
                          :queryCellInfo="customiseCell"
                          :rowSelected="interviewGridRowSelectionChanged"
                          :rowDeselected="interviewGridRowSelectionChanged"
                          :toolbarClick="interviewGridToolbarClicked"
                          :created="gridCreated(interview)"
                          :headerCellInfo="headerCellInfoEvent"
                          :enableStickyHeader="true"                        
                          v-if="interview.show">
                    <e-columns>
                        <e-column field="orderRequestNumberDisplayText" :headerText="$t('Entities.ClientOrderRequest.OrderRequestNumber')" width="100"></e-column>
                        <e-column field="orderingClientName" headerText="Client" v-if="!isClient"></e-column>
                        <e-column field="orderingClientBranchName" headerText="Branch/Location"></e-column>
                        <e-column field="orderingClientContactName" headerText="Client Contact" v-if="!isClient"></e-column>
                        <e-column field="interviewOrganisationName" headerText="Interview Organisation"></e-column>
                        <e-column field="interviewLocation" headerText="Interview Location"></e-column>
                        <e-column field="interviewMatterOrCaseReference" headerText="Interview Title"></e-column>
                        <e-column field="interviewDateTime" headerText="Interview Date / Time"></e-column>
                        <e-column field="clientReference" headerText="Client Reference"></e-column>
                        <e-column field="serviceTypeName" headerText="Service Type"></e-column>
                        <e-column field="serviceDelayName" headerText="Turnaround"></e-column>
                        <e-column field="statusDisplayName" headerText="Status" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="effectiveLastUpdateDateTimeUTC" headerText="Last Update"></e-column>
                    </e-columns>
                </ejs-grid>
            </b-tab>
        </b-tabs>

        <b-modal size="md"
                 centered
                 title="Copy Order"
                 ok-title="Yes, Copy"
                 cancel-title="No, Do Not Copy"
                 v-model="copyOrderDialogShown"
                 v-on:ok="copyOrder">
            <b-form-row>
                <b-form-group label="Do you wish to copy this order request?">
                </b-form-group>
            </b-form-row>
        </b-modal>

        <validation-observer v-slot="vp" slim>
            <b-modal size="md"
                     centered
                     no-close-on-backdrop
                     no-close-on-esc
                     title="Submit Order Request"
                     v-model="acceptTermsDialogShown"
                     v-on:ok.prevent="vp.handleSubmit(submitOrder())">
                <template #default>
                    <b-form-row>
                        <validation-provider :rules="{ required: { allowFalse: false } }"
                                             name="Accept Terms"
                                             v-slot="{ valid, errors }"
                                             slim
                                             :custom-messages="{ required: 'You have to agree to the terms of use' }">
                            <b-form-group>
                                <b-form-checkbox name="acceptTerms"
                                                 class="mb-2"
                                                 switch
                                                 v-model="acceptTerms"
                                                 :state="errors[0] ? false : null">
                                    By submitting this order, I agree to the <a href="https://www.epiqglobal.com/en-au/terms-of-use-au" target="_blank">Terms of Use</a>
                                </b-form-checkbox>
                                <b-form-invalid-feedback :state="errors[0] ? false : null">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-form-row>
                </template>
                <template #modal-footer="{ ok, cancel }">
                    <button type="button" class="btn btn-secondary" @click="cancel()">No, Do Not Submit</button>
                    <button type="button" class="btn btn-primary" @click="ok()">Yes, Agree and Submit</button>
                </template>
            </b-modal>
        </validation-observer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import { GridPlugin, ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport, DetailRow } from '@syncfusion/ej2-vue-grids';
    import { DataManager } from "@syncfusion/ej2-data";
    import axios from 'axios';
    import Visibility from 'visibilityjs';

    import VueCurrencyInput from 'vue-currency-input'
    import { ValidationProvider, ValidationObserver } from 'vee-validate';

    import { extend, localize } from 'vee-validate';
    import { required, min_value, max_value, email } from 'vee-validate/dist/rules';
    import en from 'vee-validate/dist/locale/en.json';
    extend('required', required);
    extend('min_value', min_value);
    extend('max_value', max_value);
    extend('email', email);
    localize('en', en);

    import FilterUI from './FilterUI';

    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import GridMixins from '../../mixins/GridMixins';
    import NumbersMixin from '../../mixins/NumbersMixin';
    import Select2 from '../Select2';

    Vue.use(BootstrapVue);
    Vue.use(GridPlugin)
    Vue.use(VueCurrencyInput);
    Vue.use(NumbersMixin);
    Vue.component('select2', Select2);
    Vue.component('validation-provider', ValidationProvider);
    Vue.component('validation-observer', ValidationObserver);

    //this is required to make the getGroupCaption function available globally and thus within the groupCaptionTemplate
    var vueComponent = null;
    function getGroupCaption(field, headerText, value) {
        return vueComponent.getGroupCaption(field, headerText, value);
    }
    window.getGroupCaption = getGroupCaption;

    export default {
        name: 'orderRequestsGrid',
        mixins: [ErrorsMixin, DateTimeMixin, GridMixins, NumbersMixin],
        components: {
            'filter-ui': FilterUI,
        },
        provide: {
            grid: [ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport, DetailRow]
        },
        props: {
            clientId: {
                type: String,
                default: null
            },
            isClient: {
                type: Boolean,
                default: true
            },
            canCreateOrderRequests: {
                type: Boolean,
                default: false
            },
            canSubmitOrderRequests: {
                type: Boolean,
                default: false
            },
            canCopyOrderRequests: {
                type: Boolean,
                default: false
            },
            canProcessOrderRequests: {
                type: Boolean,
                default: false
            },
            canCancelOrderRequests: {
                type: Boolean,
                default: false
            },
            allClientOrderRequestStatusOptions: {
                type: Array,
                default: null
            },
            allServiceTypeOptions: {
                type: Array,
                default: null
            },
            allServiceDelayOptions: {
                type: Array,
                default: null
            },
            initialTab: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                groupSettings: { showGroupedColumn: true, disablePageWiseAggregates: true, captionTemplate: "${getGroupCaption(field, headerText, key)}" },
                pageSettings: { pageSize: 10, pageSizes: [5, 10, 25, 50] },

                allCourtRegistries: null,
                allInterviewOrganisations: null,

                timer: null,
                refreshIntervalInMilliseconds: 3000,

                court: {
                    name: "court",
                    initialized: false,
                    dataLoaded: false,
                    show: true,
                    filterFields: [
                        {
                            field: "Status",
                            label: "Status",
                            type: "multiselect",
                            options: this.allClientOrderRequestStatusOptions,
                            placeholder: "Select Status Values"
                        },
                        {
                            field: "CourtSittingDate",
                            label: "Sitting Date",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "ServiceTypeId",
                            label: "Service Type",
                            type: "multiselect",
                            options: this.allServiceTypeOptions,
                            placeholder: "Select Service Types"
                        },
                        {
                            field: "ServiceDelayId",
                            label: "Turnaround",
                            type: "multiselect",
                            options: this.allServiceDelayOptions,
                            placeholder: "Select Turnaround Values"
                        },
                    ],
                    quickFilters: null,
                    initialFilter: null,

                    sortSettings: { columns: [{ field: "effectiveLastUpdateDateTimeUTC", direction: "Descending" }] },
                    gridDataState: {
                        filter: null,
                        search: null,
                        sorted: [{ name: "effectiveLastUpdateDateTimeUTC", direction: "descending" }],
                        group: null,
                        skip: 0,
                        take: 10,
                        requiresCounts: true
                    },
                    gridData: { result: [], count: 0 },
                    grid: null
                },

                interview: {
                    name: "interview",
                    initialized: false,
                    dataLoaded: false,
                    show: true,
                    filterFields: [
                        {
                            field: "Status",
                            label: "Status",
                            type: "multiselect",
                            options: this.allClientOrderRequestStatusOptions,
                            placeholder: "Select Status Values"
                        },
                        {
                            field: "InterviewDateTime",
                            label: "Interview Date",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "ServiceTypeId",
                            label: "Service Type",
                            type: "multiselect",
                            options: this.allServiceTypeOptions,
                            placeholder: "Select Service Types"
                        },
                        {
                            field: "ServiceDelayId",
                            label: "Turnaround",
                            type: "multiselect",
                            options: this.allServiceDelayOptions,
                            placeholder: "Select Turnaround Values"
                        },
                    ],
                    quickFilters: null,
                    initialFilter: null,

                    sortSettings: { columns: [{ field: "effectiveLastUpdateDateTimeUTC", direction: "Descending" }] },
                    gridDataState: {
                        filter: null,
                        search: null,
                        sorted: [{ name: "effectiveLastUpdateDateTimeUTC", direction: "descending" }],
                        group: null,
                        skip: 0,
                        take: 10,
                        requiresCounts: true
                    },
                    gridData: { result: [], count: 0 },
                    grid: null
                },

                initialized: false,
               
                quickFilters: null,
                initialFilter: null,

                sortSettings: { columns: [{ field: "effectiveLastUpdateDateTimeUTC", direction: "Descending" }] },
                gridDataState: {
                    filter: null,
                    search: null,
                    sorted: [{ name: "effectiveLastUpdateDateTimeUTC", direction: "descending" }],
                    group: null,
                    skip: 0,
                    take: 10,
                    requiresCounts: true
                },
                gridData: { result: [], count: 0 },
                grid: null,

                currentOrderRequest: null,
                showErrors: false,
                currentErrors: null,

                columnFormats: {                    
                    'effectiveLastUpdateDateTimeUTC': {
                        type: 'datetime'
                    },
                    'courtSittingDate': {
                        type: 'datetime',
                        options: {
                            mode: 'excludetime',
                            outputAsUTC: true
                        }
                    },
                    'interviewDateTime': {
                        type: 'datetime',
                        options: {
                            mode: 'includetime',
                            outputAsUTC: true
                        }
                    },
                },

                copyOrderDialogShown: false,

                acceptTermsDialogShown: false,
                acceptTerms: false,
            }
        },
        computed: {
            toolbar: function () {
                var toolbarItems = this.defaultEJ2DataGridToolbarItems({ grouping: false, export: true, columnchooser: true });
                if (this.canSubmitOrderRequests) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Submit Request", tooltipText: "Submit Order Request", prefixIcon: "fas fa-check", id: "submitorderrequest" },
                            ]
                        );
                }
                if (this.canCancelOrderRequests) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Cancel Request", tooltipText: "Cancel Order Request", prefixIcon: "fas fa-times", id: "cancelorderrequest" },
                            ]
                        );
                }
                if (this.canProcessOrderRequests) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Process Request as Order", tooltipText: "Process Order Request as Order", prefixIcon: "fas fa-check", id: "processorderrequest" },
                            ]
                        );
                }
                if (this.canCopyOrderRequests) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Copy", tooltipText: "Copy Order Request", prefixIcon: "fas fa-copy", id: "copyorder", cssClass: "copyorder" },
                            ]
                        );
                }
                if (this.canCreateOrderRequests) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Upload Files", tooltipText: "Upload Files to Order", prefixIcon: "fas fa-copy", id: "uploadfile", cssClass: "uploadfile" },
                            ]
                        );
                }

                return toolbarItems;
            },            
            tabsNavClass: function () {
                var tabsNavClass = "border-bottom-0";
                //if (!this.canViewCourtOrders || !this.canViewInterviewOrders) tabsNavClass += " d-none";
                return tabsNavClass;
            },
        },
        methods: {            
            getGroupCaption: function (field, headerText, value) {
                if (field == "createdDateTimeUTC") value = this.dateTimeDisplayString(value, 'includetime', true, false);
                else if (field == "courtSittingDate") value = this.dateTimeDisplayString(value, 'excludetime', true, true);
                else if (field == "interviewDateTime") value = this.dateTimeDisplayString(value, 'includetime', true, true);
                return headerText + ": " + value;
            },
            customizeGroupKeys(groupedDate) {
                groupedDate.forEach(g => {
                    if (g.field && g.key && g.items) {
                        if (g.field == "createdDateTimeUTC") g.key = this.dateTimeDisplayString(g.key, 'includetime', true, false);
                        else if (g.field == "courtSittingDate") g.key = this.dateTimeDisplayString(g.key, 'excludetime', true, true);                            
                        else if (g.field == "interviewDateTime") g.key = this.dateTimeDisplayString(g.key, 'includetime', true, true);
                        this.customizeGroupKeys(g.items);
                    }
                });
            },
            customiseCell: function (args) {
                if ((args.column.field == 'orderRequestNumberDisplayText') && (args.name == 'queryCellInfo')) {
                    args.cell.innerHTML = "<a href='" + this.$urlHelper.getPageUrl('OrderRequests/Edit', [args.data.clientOrderRequestId ?? args.data.orderId, args.data.courtSittingId]) + "' target='_blank'>" + args.data.orderRequestNumberDisplayText + "</a>";
                }
                this.defaultEJ2DataGridQueryCellInfo(args, this.columnFormats);
            },

            courtFilterChanged: function (filter) {
                this.filterChanged(this.court, filter);
            },
            courtGridDataStateChanged: function (args) {
                this.gridDataStateChanged(this.court, args);
            },
            courtGridRowSelectionChanged: function (args) {
                this.rowSelectionChanged(this.court.grid, args);
            },
            courtGridToolbarClicked: function (args) {
                this.toolbarClicked(this.court, args);
            },

            interviewFilterChanged: function (filter) {
                this.filterChanged(this.interview, filter);
            },
            interviewGridDataStateChanged: function (args) {
                this.gridDataStateChanged(this.interview, args);
            },
            interviewGridRowSelectionChanged: function (args) {
                this.rowSelectionChanged(this.interview.grid, args);
            },
            interviewGridToolbarClicked: function (args) {
                this.toolbarClicked(this.interview, args);
            },

            filterChanged: function (relatedTo, filter) {
                relatedTo.gridDataState.filter = filter;
                if (relatedTo.initialized) relatedTo.grid.refresh();
            },
            gridDataStateChanged: function (relatedTo, args) {
                relatedTo.gridDataState.search = args.search;
                relatedTo.gridDataState.sorted = args.sorted;
                relatedTo.gridDataState.group = args.group;
                relatedTo.gridDataState.skip = args.skip;
                relatedTo.gridDataState.take = args.take;
                relatedTo.gridDataState.requiresCounts = args.requiresCounts;
                if (relatedTo.initialized) {
                    relatedTo.grid.showSpinner();
                    this.loadRequests(relatedTo.name, relatedTo.gridDataState)
                        .then(result => {
                            if (result) {
                                relatedTo.gridData = result;
                            }
                            relatedTo.grid.hideSpinner();
                        });
                }
            },
            toolbarClicked: function (relatedTo, args) {    
                if ((args.item.id === 'submitorderrequest') ||
                    (args.item.id === 'cancelorderrequest') ||
                    (args.item.id === 'processorderrequest') ||
                    (args.item.id === 'copyorder') ||
                    (args.item.id === 'uploadfile')) {
                    this.handleAction(args.item.id, relatedTo.grid.getSelectedRecords()[0], relatedTo.grid);
                } else if (args.item.id === 'reset') {
                    this.deleteGridSettings(relatedTo.grid)
                        .then(() => {
                            relatedTo.gridDataState.search = "";
                            relatedTo.show = false;
                            Vue.nextTick(() => {
                                relatedTo.show = true;
                                Vue.nextTick(() => {
                                    relatedTo.grid = (relatedTo.name == "court") ? this.$refs.clientCourtOrderRequestsGrid.ej2Instances : this.$refs.clientInterviewOrderRequestsGrid.ej2Instances;
                                    this.setupGridPersistence(relatedTo.grid);
                                    this.updateToolbarItems(relatedTo.grid, null);
                                    relatedTo.grid.refresh();
                                });
                            });
                        });
                } else if (args.item.id === 'excelexport') {
                    //to properly export all data (and not just the entries displayed on the current page) we have to load everything first
                    //we do this by taking the current grid state (which includes the current filter and search and sort settings)
                    var gridDataState = {
                        ...relatedTo.gridDataState
                    };
                    //but reset the skip and take to 0 which will return everything and unset the requiresCounts cause we are not interseted in the totals
                    gridDataState.requiresCounts = false;
                    relatedTo.grid.showSpinner();
                    this.loadRequests(relatedTo.name, gridDataState)
                        .then(result => {
                            //the result is either false if something failed during the axios request, or it will contain the list in the result property which is what we have to pass to the actual export
                            if (result) {
                                var query = relatedTo.grid.getDataModule().generateQuery(true);
                                var groupedData = new DataManager(result.result).executeLocal(query);
                                this.customizeGroupKeys(groupedData);
                                relatedTo.grid.excelExport({ dataSource: groupedData });
                            }
                            relatedTo.grid.hideSpinner();
                        });
                } else {
                    this.defaultEJ2DataGridToolbarClickHandler(args, relatedTo.grid);
                }
            },
            reloadDummy: function () {
                console.log('reloading grid.')
            },
            handleAction: function (action, orderRequest, grid) {
                if (action === 'submitorderrequest') {
                    this.showTerms();
                    this.currentGrid = grid;
                    this.currentOrderRequest = orderRequest;
                }
                else if (action === 'cancelorderrequest') {
                    this.$bvModal.msgBoxConfirm(
                        [
                            this.$createElement(
                                'div',
                                {
                                    domProps:
                                    {
                                        innerHTML: "<p>Are you sure you want to cancel the order request?</p>"
                                    }
                                }
                            )
                        ],
                        {
                            title: 'Cancel Order Request',
                            size: 'md',
                            okVariant: 'danger',
                            okTitle: 'Yes, Cancel Order Request',
                            cancelTitle: 'No, Do Not Cancel',
                            centered: true
                        })
                        .then(value => {
                            if (value) {
                                this.cancelSubmissionManually(orderRequest.clientOrderRequestId);
                            }
                        });
                }
                else if (action === 'processorderrequest') {
                    this.$bvModal.msgBoxConfirm(
                        [
                            this.$createElement(
                                'div',
                                {
                                    domProps:
                                    {
                                        innerHTML: "<p>Are you sure you want to process the request as an order?</p>"
                                    }
                                }
                            )
                        ],
                        {
                            title: 'Process Order Request',
                            size: 'md',
                            okVariant: 'success',
                            okTitle: 'Yes, Process Request as Order',
                            cancelTitle: 'No, Do Not Process',
                            centered: true
                        })
                        .then(value => {
                            if (value) {
                                this.processOrderManually(orderRequest.clientOrderRequestId);
                            }
                        });
                }
                else if (action === 'copyorder') {
                    this.currentOrderRequest = orderRequest;
                    this.currentGrid = grid;
                    this.currentErrors = null;
                    this.showErrors = false;
                    this.copyOrderDialogShown = true;
                }
                else if (action === 'uploadfile') {
                    window.open(this.$urlHelper.getPageUrl("OrderRequests/FileUpload"), "_blank");
                }
            },
            submitOrder: function () {
                if (this.acceptTerms != true) {
                    return;
                }

                this.acceptTermsDialogShown = false;
                this.acceptTerms = false;
                this.processSubmissionManually(this.currentOrderRequest.clientOrderRequestId);
            },
            rowSelectionChanged: function (grid, args) {
                if (args.name == 'rowSelected') {
                    this.updateToolbarItems(grid, grid.getSelectedRecords()[0])
                } else {
                    this.updateToolbarItems(grid, null)
                }
            },
            updateToolbarItems: function (grid, orderRequest) {
                if (this.canSubmitOrderRequests) {
                    this.setToolbarItemState(grid, 'submitorderrequest', (orderRequest != null) && (orderRequest.enableSubmission == true));
                }
                if (this.canCancelOrderRequests) {
                    this.setToolbarItemState(grid, 'cancelorderrequest', (orderRequest != null) && (orderRequest.enableCancellation == true));
                }
                if (this.canProcessOrderRequests) {
                    this.setToolbarItemState(grid, 'processorderrequest', (orderRequest != null) && (orderRequest.enableProcessing == true));
                }
                if (this.canCopyOrderRequests) {
                    this.setToolbarItemState(grid, 'copyorder', (orderRequest != null) && (orderRequest.enableCopy == true));
                }
            },
            setToolbarItemState: function (grid, itemClass, enabled) {
                grid.toolbarModule.enableItems([itemClass], enabled);
            },

            loadRequests: function (relatedToName, gridDataState) {
                var url = this.$urlHelper.getApiUrl('ClientOrderRequest', 'list', [relatedToName]);
                
                return axios
                    .post(url, JSON.stringify(gridDataState), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        var gridData = response.data;
                        if (gridData && gridData.result) {
                            gridData.result = gridData.result.map((orderRequest) => {
                                if (orderRequest.createdDateTimeUTC) orderRequest.createdDateTimeUTC = this.parseDateTime(orderRequest.createdDateTimeUTC, true, true);
                                if (orderRequest.sittingDate) orderRequest.sittingDate = this.parseDateTime(orderRequest.sittingDate, true, true);
                                return orderRequest;
                            });
                        }
                        return gridData;
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                        return false;
                    });
            },  
            gridCreated: function (relatedTo) {
                Vue.nextTick(() => {
                    this.defaultEJ2DataGridCreatedHandler(relatedTo.grid);
                });
            },

            processSubmissionManually: function (orderRequestId) {
                var path = 'ClientOrderRequest/' + orderRequestId;
                var url = this.$urlHelper.getApiUrl(path, 'submit');
                var data =
                {
                    
                };
                axios
                    .post(url, JSON.stringify(data), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {
                        this.$bvToast.toast('Order request submitted successfully', {
                            title: 'Order Request Updated',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    })
                    .finally(() => {
                        this.grid.refresh();
                    });
            },

            cancelSubmissionManually: function (orderRequestId) {
                var path = 'ClientOrderRequest/' + orderRequestId;
                var url = this.$urlHelper.getApiUrl(path, 'cancel');
                var data =
                {
                    
                };
                axios
                    .post(url, JSON.stringify(data), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {
                        this.$bvToast.toast('Order request cancelled successfully', {
                            title: 'Order Request Cancelled',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    })
                    .finally(() => {
                        this.grid.refresh();
                    });
            },

            processOrderManually: function (orderRequestId) {
                var url = this.$urlHelper.getPageUrl('Orders/ProcessOrderRequest', [orderRequestId]);
                console.log('process url: ' + url);
                this.currentOrderRequest = null;
                Vue.nextTick(() => {
                    window.open(url);
                });
            },

            copyOrder: function () {
                var orderRequestId = this.currentOrderRequest.clientOrderRequestId;
                var url = this.$urlHelper.getPageUrl('OrderRequests/Copy', [orderRequestId]);
                console.log('copy url: ' + url);
                this.currentOrderRequest = null;
                this.copyOrderDialogShown = false;
                Vue.nextTick(() => {
                    window.open(url);
                });
            },     

            showTerms: function () {
                this.acceptTerms = false;
                this.acceptTermsDialogShown = true;
            },

            tabActivated: function (relatedTo) {
                if (!relatedTo.dataLoaded) {
                    relatedTo.grid.refresh();
                    relatedTo.dataLoaded = true;
                }
            },
        },

        mounted: function () {
            vueComponent = this;
            this.court.grid = this.$refs.clientCourtOrderRequestsGrid.ej2Instances;
            this.setupGridPersistence(this.court.grid);
            this.updateToolbarItems(this.court.grid, null);
            this.$refs.clientCourtOrderRequestsGridFilter.loadQuickFilters()
                .then(() => {
                    this.court.initialized = true;
                    if (this.initialTab == 'Court') {
                        setTimeout(() => {
                            this.court.grid.refresh();
                            this.court.dataLoaded = true;
                        }, 250);
                    }
            });

            this.interview.grid = this.$refs.clientInterviewOrderRequestsGrid.ej2Instances;
            this.setupGridPersistence(this.interview.grid);
            this.updateToolbarItems(this.interview.grid, null);
            this.$refs.clientInterviewOrderRequestsGridFilter.loadQuickFilters()
                .then(() => {
                    this.interview.initialized = true;
                    if (this.initialTab == 'Interview') {
                        setTimeout(() => {
                            this.interview.grid.refresh();
                            this.interview.dataLoaded = true;
                        }, 250);
                    }
            });

            this.timer = Visibility.every(this.refreshIntervalInMilliseconds, this.reloadDummy);
        }
    }
</script>
